import { render } from "./PasswordValidation.vue?vue&type=template&id=0af6b234"
import script from "./PasswordValidation.vue?vue&type=script&lang=js"
export * from "./PasswordValidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__